<template>
  <el-row :gutter="40">
    <el-col :md="12" :xs="24">
      <TimeSearch
          :full-width-select="true"
          ref="timeSearch"
          :short-date="true"
          :month="true"
          :free-date-time="true"
      />
    </el-col>
    <el-col :md="12" :xs="24">
      <el-form label-position="top" style="width: 100%">

        <slot name="admin-extension"></slot>
        <slot name="client-extension"></slot>

        <el-form-item label="Номер телефона">
          <el-input v-model="searchPhone"></el-input>
        </el-form-item>
        <el-form-item label="Поиск по событию">
          <el-select v-model="searchToken" class="full-width">
            <el-option label="Все" value="" />
            <el-option
                v-for="status in errorMessages"
                :label="status" :value="status"
            />
          </el-select>
<!--                  <el-input v-model="searchToken"></el-input>-->
          <el-checkbox v-model="excludeToken" label="Не содержит данного значения"></el-checkbox>
        </el-form-item>
      </el-form>
    </el-col>
  </el-row>

  <el-button type="success" plain @click="getReport(true)" :loading="reportLoading" :disabled="reportButtonDisabled" style="margin-top: 15px">Применить</el-button>

  <el-row v-show="reportReady">
    <EventsTable
      :page-loading="pageLoading"
      :all-events="allEvents"
      :total-events="totalEvents"
      :report-params="reportParams"
      :download-url="downloadReportUrl"
      @pagination-changed="handlePaginationEvents"
    />
  </el-row>
</template>

<script>
import TimeSearch from "@shared/components/reports/time-search.component"
import EventsTable from "@shared/components/reports/event-log/table/events-table.component"

export default {
  name: "EventLogReport",
  props: {
    getReportUrl: String,
    downloadReportUrl: String,
    mutateParams: {
      type: Function,
      default: p => p
    },
    reportButtonDisabled: {
      type: Boolean,
      default: false
    }
  },
  components: {TimeSearch, EventsTable},
  methods: {
    handlePaginationEvents(event){
      if (event.size){this.pageSize = event.size}
      if (event.page){this.currentPage = event.page}
      this.getReport()
    },
    getReportParams() {
      let dateFilter = this.$refs.timeSearch.getDateTimeFilter()
      return this.mutateParams({
        date_from: dateFilter.from.toDate(),
        date_to: dateFilter.to.toDate(),
        searchToken: this.searchToken,
        searchPhone: this.searchPhone,
        excludeToken: this.excludeToken,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
      })
    },
    async getReport(doCount = false) {
      this.pageLoading = true
      if (doCount){this.reportLoading = true}
      this.reportParams = this.getReportParams()
      this.reportParams.doCount = doCount
      let resp = await this.axios.get(this.getReportUrl, {params: this.reportParams})
      this.allEvents = resp.data.events
      this.pageLoading = false
      if (doCount){
        this.totalEvents = resp.data.count
        this.reportLoading = false
        this.reportReady = true
      }
    },
  },
  data() {
    return {
      reportReady: false,
      reportLoading: false,
      reportParams: {},
      pageLoading: false,
      searchCategory: "",
      searchTask: "",
      searchToken: "",
      searchPhone: "",
      tableSearchToken: "",
      excludeToken: false,
      allEvents: [],
      totalEvents: 0,
      pageSize: 10,
      currentPage: 1,
      errorMessages: [
        "Данная подпись отправителя не подтверждена",
        "Отправка заблокирована, номер телефона находится в черном списке",
        "Некорректный номер телефона , сообщение на этот номер не отправлено",
        "Слишком частая отправка одинаковых сообщений на один номер",
        "Превышен лимит отправки сообщений 1 абоненту в сутки",
        "Превышен суточный лимит затрат на отправку сообщений",
        "Не достаточно средств на счету",
        "Длинна сообщения больше 480 символов",
        "Текст международной СМС не подходит для конвертации",
        "Отправка международных сообщений закрыта",
        "Сообщение не прошло модерацию",
        "Сообщение не прошло ручную модерацию",
        "Сообщение отправлено на ручную модерацию",

        "Данное направление не подключено",
        "Telegram бот не активен",
        "Telegram контакт не активен",
        "Сообщение не прошло тарификацию",
        "В тестовом доступе разрешена отправка только на свой номер, подтвержденный при регистрации",
        "В тестовом доступе разрешены звонки только на свой номер, подтвержденный при регистрации",
        "Счёт заблокирован"
      ]
    }
  },
}
</script>